import IAlertService from "../../services/alert/IAlertService";
import { container } from "@/inversify.config";
import { DiTokens } from "../../services/diTokens";
import Vue from "vue";
import { callSignalRMethod, createSignalR, signalREventHandler, startSignalR } from '../../services/api/signalR';
import { Message, MessageStatus } from '../../data/chat';
import { getMessagesAction } from '../../services/chat/chat';

/**
 *  Класс для компоненты чата
 */
export class ChatVue extends Vue {
  chatMessages: Array<Message> = []
  connection: any = null;
  newCount: number = 0;
  loading: boolean = true;

  timer: any = null;

  async init(): Promise<void> {
    await this.loadMessages()
    if (!this.connection) {
      this.connection = createSignalR("/chat")

      signalREventHandler(this.connection, "ReceiveStatus", (message: Message) => this.receiveStatusEvent(message))
      signalREventHandler(this.connection, "ReceiveMessage", (message: Message) => this.receiveMessageEvent(message))
      startSignalR(this.connection).then(() => {

      }).catch((err) => {
        this.alertService.error(err.toString());
      });
    }
    this.loading = false;
    this.scrollToBottom();
  }

  receiveMessageEvent(message: Message) {
    if (message.IsBankMessage) {
      this.chatMessages.push(message)
      this.newCount++;
    }
    this.scrollToBottom()
  }

  receiveStatusEvent(message: Message) {
    const itemIndex: number = this.chatMessages.findIndex(
      (m: Message) => {
        if (m.Id == message.Id) return m;
      }
    );

    if(itemIndex >= 0) {
      this.chatMessages[itemIndex].Status = message.Status
    } else {
      this.chatMessages.push(message)
    }

    this.scrollToBottom()
  }

  /**
 * Сервис уведомлений
 * @returns {IAlertService}
 */
  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }


  /** Индикатор открытия чата */
  chatIsOpen: boolean = false

  /** Текст сообщения пользователя */
  messageText: string = ''



  subscribeFlag: boolean = true


  /**
 * Получние дом элемента контента чата
 * @returns {Element} - ссылка на дом объект чата.
 */
  get chatContent(): HTMLElement | null {
    return document.getElementById('content')
  }

  /** Открытие чата, запуск плагина для плавного скролла */
  openChat() {
    this.scrollToBottom();
    this.chatIsOpen = !this.chatIsOpen;

  }
  sendStatus() {
    this.chatMessages
      .filter((m: Message) => {
        return this.isNewMessage(m);
      })
      .forEach(async (m: Message) => {
        const oldStatus: MessageStatus = m.Status;
        m.Status = MessageStatus.Read;
        await callSignalRMethod(this.connection, "SendStatus", m);
      });
    this.newCount = 0;
  }

  isNewMessage(m: Message): boolean {
    return m.IsBankMessage && m.Status != MessageStatus.Read;
  }
  /** Отправка сообщения пользователя и прокрутка чата вниз */
  async sendMessage() {
    if (this.messageText !== '') {
      await callSignalRMethod(this.connection, "SendMessage", this.createMessageObject(this.messageText))
      this.scrollToBottom();
      this.messageText = '';
    }
  }

  scrollToBottom(): void {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {
      this.chatContent?.scroll({ top: this.chatContent.scrollHeight + 500, left: 0, behavior: 'smooth' });
    }, 500);
  }

  createMessageObject(text: string): Message {
    const msg: Message = {
      Id: undefined,
      Text: text,
      Status: MessageStatus.Sent,
      IsBankMessage: false,
      CreatedAt: undefined
    };

    return msg;
  }

  /** Подписка на получение сообщений чата, каждые 10 секунд */
  async loadMessages() {
    await getMessagesAction((chat: Message[]) => {
      this.chatMessages = chat;
      this.newCount = this.chatMessages.filter((m: Message) => {
        return m.IsBankMessage && m.Status != MessageStatus.Read;
      }).length;
    },
      (err: string) => {
        this.alertService.error(err);
      });
  }
}
